export const toBoolean = (input) => {
  if (input === "true") {
    return true;
  }
  return false;
};


